<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table ref="dataTable" :headers="headers" :items="getDataTable" :search="search">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.foto="{ item }">
          <v-img
            contain
            max-height="100"
            max-width="100"
            :src="item.foto ? 'data:image/png;base64,' + item.foto : ''"
          ></v-img>
        </template>

        <template v-slot:item.ativo="{ item }">
          <v-btn color="transparent" small fab depressed>
            <v-icon
              :color="item.ativo ? 'green' : 'red'"
              @click="$ability.can('Editar', 'Veiculos') ? updateAtivo(item) : ''"
            >{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.acao="{ item }">
          <v-tooltip v-if="$ability.can('Vincular Empresa', 'Produto Forca')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogVincular.show(item)"
              >
                <v-icon>mdi-link-variant</v-icon>
              </v-btn>
            </template>
            Vincular Veiculo a Empresas
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Editar', 'Produto Forca')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogFormProdutoForca.show(true, item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            Editar Veiculo
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogVincular @updated="updateEmpresas($event)" ref="dialogVincular" />
      <DialogFormProdutoForca @updated="update($event)" ref="dialogFormProdutoForca" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Veiculo from "@/services/produtoForca";
export default {
  name: "TableProdutoForca",

  components: {
    DialogVincular: () => import("./DialogVincular"),
    DialogFormProdutoForca: () => import("./DialogFormProdutoForca")
  },

  data() {
    return {
      headers: [
        { text: "Imagem", value: "foto" },
        { text: "Tipo", value: "tipo" },
        { text: "Modelo", value: "modelo" },
        { text: "Potência", value: "potencia" },
        { text: "Especificação", value: "especificacao" },
        { text: "Preço Norte", value: "precoRegioes.Norte" },
        { text: "Preço Centro-Oeste", value: "precoRegioes.Centro-Oeste" },
        { text: "Fabricante", value: "fabricante" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "acao", sortable: false, align: "center" }
      ],
      search: "",
      veiculoService: new Veiculo()
    };
  },

  computed: {
    ...mapGetters("produtoForca", ["getProdutoForca"]),
    getDataTable() {
      return this.getProdutoForca === null ? [] : this.getProdutoForca;
    }
    // produtroForca: {
    //   set(value) {
    //     this.actionProdutoForca(value);
    //   },
    //   get() {
    //     return this.getProdutoForca;
    //   }
    // }
  },

  methods: {
    update(newVeiculo) {
      let index = this.$refs.dataTable.items.findIndex(
        item => item.id === newVeiculo[1]
      );
      this.$refs.dataTable.items[index].foto = newVeiculo[0].foto;
      this.$refs.dataTable.items[index].modelo = newVeiculo[0].modelo;
      this.$refs.dataTable.items[index].tipo = newVeiculo[0].tipo;
      this.$refs.dataTable.items[index].potencia = newVeiculo[0].potencia;
      this.$refs.dataTable.items[index].especificacao =
        newVeiculo[0].especificacao;
      this.$refs.dataTable.items[index].precoRegioes["Norte"] =
        newVeiculo[0].precoRegioes["Norte"];
      this.$refs.dataTable.items[index].precoRegioes["Centro-Oeste"] =
        newVeiculo[0].precoRegioes["Centro-Oeste"];
    },

    updateEmpresas(veiculo) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === veiculo.id
      );
      if (veiculo.empresas.length === 0) {
        this.$refs.dataTable.items[index].empresas = [];
      } else {
        this.$refs.dataTable.items[index].empresas = veiculo.empresas.map(
          empresa => empresa
        );
      }
    },

    updateAtivo(veiculo) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === veiculo.id
      );
      let texto = "";
      if (veiculo.ativo) {
        texto = `Deseja Desativar a ${veiculo.descricao}?`;
      } else {
        texto = `Deseja Ativar ${veiculo.descricao}?`;
      }
      this.$swal.confirm(texto).then(async () => {
        try {
          veiculo.ativo = !veiculo.ativo;
          await this.veiculoService.update(veiculo.id, { ...veiculo });
          this.$refs.dataTable.items.splice(index, 1);
          return Promise.resolve();
        } catch (error) {
          veiculo.ativo = !veiculo.ativo;
          await this.veiculoService.update(veiculo.id, { ...veiculo });
          this.$toast.error(`Erro ao atualizar ativo`);
          return Promise.reject(error);
        }
      });
    }
  }
};
</script>

<style></style>
